import { Component } from '@theme/component';

/**
 * @extends {Component}
 */
class BrandSwitcher extends Component {
  /** @type {HTMLAnchorElement | null} */
  #pressedLink = null;

  /** @type {number | null} */
  #pressedTimeout = null;

  /** @type {number | null} */
  #readyFrameId = null;

  connectedCallback() {
    super.connectedCallback();
    this.#markReady();
    this.addEventListener('pointerdown', this.#onPointerDown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('pointerdown', this.#onPointerDown);
    this.#clearPressed();

    if (this.#readyFrameId !== null) {
      window.cancelAnimationFrame(this.#readyFrameId);
      this.#readyFrameId = null;
    }
  }

  /**
   * @param {PointerEvent} event
   */
  #onPointerDown = (event) => {
    if (event.button !== 0 || !(event.target instanceof Element)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('.brand-switcher__item');
    if (!(link instanceof HTMLAnchorElement)) return;

    this.#clearPressed();
    this.#pressedLink = link;
    this.#pressedLink.classList.add('is-tapped');
    this.#pressedTimeout = window.setTimeout(() => this.#clearPressed(), 180);
  };

  #clearPressed() {
    if (this.#pressedTimeout !== null) {
      window.clearTimeout(this.#pressedTimeout);
      this.#pressedTimeout = null;
    }

    if (!this.#pressedLink) return;

    this.#pressedLink.classList.remove('is-tapped');
    this.#pressedLink = null;
  }

  #markReady() {
    if (this.#readyFrameId !== null) {
      window.cancelAnimationFrame(this.#readyFrameId);
    }

    this.#readyFrameId = window.requestAnimationFrame(() => {
      this.#readyFrameId = window.requestAnimationFrame(() => {
        this.setAttribute('data-ready', '');
        this.#readyFrameId = null;
      });
    });
  }
}

if (!customElements.get('brand-switcher-component')) {
  customElements.define('brand-switcher-component', BrandSwitcher);
}
